export default {
	home: {
		afunOriginals: "AFun Asli",
		slots: "Slot",
		liveCasino: "Kasino Langsung",
		casualGames: "Permainan Santai",
		newReleases: "Keluaran Baharu",
		casinoTitle: "Kasino",
		casinoDesc: "Nikmati permainan kasino dengan beribu-ribu slot, penjual langsung dan permainan meja",
		goToCasino: "Pergi ke Kasino",
		sportsTitle: "Sukan",
		sportsDesc: "Pertaruhan pada Bola Sepak, Bola Keranjang, Tenis dan lebih banyak sukan dengan odds terbaik",
		goToSports: "Pergi ke Sukan",
		liveTitle: "Langsung",
		liveDesc: "Aksi masa nyata dengan penjual langsung dan pengalaman permainan interaktif",
		goToLive: "Pergi ke Langsung",
		latestBetRace: "Pertaruhan & Perlumbaan Terkini",
		sports: "Sukan",
		latestBets: "Pertaruhan Terkini",
		game: "Permainan",
		player: "Pemain",
		bet: "Pertaruhan",
		multiplier: "Pengganda",
		profit: "Keuntungan",
		top10Games: "10 Permainan Teratas",
		vip: "VIP",
		rewards: "Ganjaran",
		affiliate: "Afiliasi",
		promotion: "Promosi"
	},

	latestBetRace: {
		title: "Grand Prix Papan Pendahulu Permainan",
		playerBetRank: "Taruhan Pemain Hari Ini",
		playerWinRank: "Kemenangan Pemain Hari Ini",
		gameBetRank: "Taruhan Permainan Hari Ini",
		gameWinRank: "Pulangan Permainan Hari Ini",
		player: "Pemain",
		game: "Permainan",
		bet: "Taruhan",
		profit: "Menang",
		ratio: "Nisbah Pembayaran",
		totalBet: "Jumlah Taruhan",
		totalReturn: "Jumlah Pulangan",
		maxBet: "Taruhan Maks",
		gameRatio: "% Pulangan",
		noData: "Tiada Data Tersedia",
	},

	GameClassify: {
		casinoTitle: "Kasino",
		casinoDesc: "Nikmati permainan kasino daripada pembekal terkemuka",
		casinoBtn: "Pergi ke Kasino",
		sportsTitle: "Sukan",
		sportsDesc: "Pertaruhan Bola Sepak, Kriket, NFL, eSukan & lebih 80 jenis sukan",
		sportsBtn: "Pergi ke Sukan",
		liveTitle: "Langsung",
		liveDesc: "Aksi masa nyata bersama pengedar langsung",
		liveBtn: "Pergi ke Live"
	}
}